export default __webpack_public_path__ + "static/media/coloured-card.32d978e8.jpg";